import React from 'react';
import classNames from 'classnames';
// import { useIntl } from 'react-intl';

import styles from './CarouselDots.module.scss';

// const messages = {
//   slideCounter: {
//     id: 'carouselDots.slideCounter',
//     description: 'Text to show slide index to total number of slides',
//   },
// };

interface CarouselDotsProps {
  numDots: number;
  currentIndex?: number | null;
}

const CarouselDots = ({ numDots, currentIndex = 0 }: CarouselDotsProps) => {
  // const intl = useIntl();

  // const slideCount = intl.formatMessage(messages.slideCounter, {
  //   index: currentIndex + 1,
  //   total: numDots,
  // });
  const dots = [];
  for (let i = 0; i < numDots; i += 1) {
    dots.push(
      <span
        key={i}
        id={`carousel-dot-${i}`}
        className={classNames(
          styles.dot,
          {
            [styles.hasFocus]: currentIndex === i,
          },
          'd-inline-block',
          'align-middle',
        )}
      />,
    );
  }

  return (
    <div id="carousel-dots" className={styles.carouselDotsContainer}>
      {dots}
    </div>
  );
};

export default React.memo(CarouselDots);
